import * as AppConstants from 'app/AppConstants';

const initialState = () => ({
  isDownloading: false,
});

export default (state = initialState(), action) => {
  switch (action.type) {
    case AppConstants.CARD__EXPORT_DOWNLOAD_STARTED: {
      return {...state, isDownloading: true};
    }

    case AppConstants.CARD__EXPORT_DOWNLOAD_FINISHED:
    case AppConstants.CARD__EXPORT_DOWNLOAD_FAILED: {
      return {...state, isDownloading: false};
    }

    default:
      return state;
  }
};
